module.exports = __webpack_public_path__ + "7870ee8f882ed45d9b28319d2060ce0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/make-moves-together/cha-medals.png
// module id = 1752
// module chunks = 1